import { render, staticRenderFns } from "./PeopleTimeIcon.vue?vue&type=template&id=1f476a60&"
import script from "./PeopleTimeIcon.vue?vue&type=script&lang=ts&"
export * from "./PeopleTimeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports